const Styleselect = {
            control: (base) => ({
                ...base,
                minHeight: 28,   // Hauteur réduite
                height: 28,
                fontSize: 12,
            }),
            valueContainer: (base) => ({
                ...base,
                height: 28,
                padding: "0 6px",  // réduit le padding vertical
            }),
            singleValue: (base) => ({
                ...base,
                fontSize: 12,
                lineHeight: "28px", // assure que le texte est centré
            }),
            input: (base) => ({
                ...base,
                fontSize: 12,
                margin: 0,
                padding: 0,
            }),
            placeholder: (base) => ({
                ...base,
                fontSize: 12,
                lineHeight: "28px",
            }),
        };
export default Styleselect;